import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
const TagStatisticSkeleton: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-skeleton-primary w-full animate-pulse rounded-md text-transparent">.</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default TagStatisticSkeleton;